var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mostraBloco
    ? _c("div", { staticClass: "next-steps ia-block-card" }, [
        _c(
          "div",
          {
            staticClass:
              "ia-block-card__cabecalho ia-block-card__cabecalho--fita"
          },
          [
            _c("icon-svg", {
              staticClass: "ia-block-card__icone",
              attrs: { name: "task-square", size: 14, color: "var(--primary)" }
            }),
            _c("span", { staticClass: "ia-block-card__titulo" }, [
              _vm._v(" " + _vm._s(_vm.titulo) + " ")
            ])
          ],
          1
        ),
        _c(
          "ol",
          { staticClass: "next-steps__lista" },
          _vm._l(_vm.itens, function(item) {
            return _c(
              "li",
              { key: item.chave, staticClass: "next-steps__item" },
              [
                _c("span", { staticClass: "next-steps__ordem ia-texto-selo" }, [
                  _vm._v(_vm._s(item.ordem))
                ]),
                _c("span", { staticClass: "next-steps__corpo" }, [
                  _c("span", { staticClass: "next-steps__topo" }, [
                    _c(
                      "span",
                      { staticClass: "next-steps__titulo ia-texto-auxiliar" },
                      [_vm._v(_vm._s(item.passo.title))]
                    ),
                    item.passo.badge
                      ? _c(
                          "span",
                          {
                            staticClass: "next-steps__badge ia-texto-micro",
                            class: item.classeBadge
                          },
                          [_vm._v(_vm._s(item.passo.badge))]
                        )
                      : _vm._e()
                  ]),
                  item.passo.description
                    ? _c(
                        "span",
                        {
                          staticClass: "next-steps__descricao ia-texto-auxiliar"
                        },
                        [_vm._v(_vm._s(item.passo.description))]
                      )
                    : _vm._e()
                ])
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }